import { render, staticRenderFns } from "./IntegrationList.vue?vue&type=template&id=5488a231&scoped=true&lang=pug&"
import script from "./IntegrationList.vue?vue&type=script&lang=js&"
export * from "./IntegrationList.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationList.vue?vue&type=style&index=0&id=5488a231&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488a231",
  null
  
)

export default component.exports